import { useCallback } from "react";

export function getEditUserProfileValidationForm(Yup) {
  return Yup.object().shape({
    firstName: Yup.string().required("FirstName is required"),
    mobileNo: Yup.string()
      .matches(/^[0-9\b]+$/, "Mobile Number not valid")
      .min(10, "Min 10 digits required")
      .max(10, "Max 10 digits required"),
  });
}

export const onModalSubmit = ({ dialogData, options }) => {
  options?.onSubmit?.(dialogData);
};

export function getEnableChangePasswordAndMobileNumberFields(getRuntimeConfig) {
  return JSON.parse(getRuntimeConfig()?.enableChangePasswordAndMobileNumberFields || "{}");
}

export function handleProfilePicModalSubmit({ handleProfilePic, tempAvatarSelection, setShowUploadAvatar }) {
  handleProfilePic(tempAvatarSelection);
  setShowUploadAvatar(false);
}
export function handleProfilePicModalCancel({ setShowUploadAvatar, setTempAvatarSelection, userData }) {
  setTempAvatarSelection(userData?.userPicURL);
  setShowUploadAvatar(false);
}
export function handleFormikSubmit(data, { setSubmitting }) {
  const updateBody = {};
  updateBody["userId"] = data.email;
  updateBody["firstName"] = data.firstName;
  updateBody["lastName"] = data.lastName;
  updateBody["mobileNo"] = data.mobileNo;
  onModalSubmit(data);
  setSubmitting(false);
}

export function AvatarImage({ avatar, setTempAvatarSelection, ...props }) {
  const _setTempAvatarSelection = useCallback(
    () => setTempAvatarSelection(avatar.alt),
    [avatar.alt, setTempAvatarSelection]
  );
  return <img onClick={_setTempAvatarSelection} {...props}></img>;
}
